(function () {
  let cartExtraRequestInProgress = false;

  function handleCartError(error, message) {
    console.error(error);
    alert(message);
  }

  function getCartItemsElement() {
    return document.querySelector('cart-items');
  }

  function getSectionsToRender() {
    const cartItems = getCartItemsElement();

    if (
      cartItems &&
      typeof cartItems.getSectionsToRender === 'function'
    ) {
      return cartItems.getSectionsToRender();
    }

    return [];
  }

  function getSectionInnerHTML(html, selector) {
    const parsedHtml = new DOMParser().parseFromString(
      html,
      'text/html'
    );

    const element = parsedHtml.querySelector(selector);

    return element ? element.innerHTML : '';
  }

  function renderCartSections(parsedState) {
    const cartItems = getCartItemsElement();
    const sections = getSectionsToRender();

    if (!cartItems || !parsedState.sections) {
      throw new Error('Cart sections could not be rendered');
    }

    cartItems.classList.toggle(
      'is-empty',
      parsedState.item_count === 0
    );

    const cartFooter = document.getElementById('main-cart-footer');

    if (cartFooter) {
      cartFooter.classList.toggle(
        'is-empty',
        parsedState.item_count === 0
      );
    }

    const cartDrawer = document.querySelector('cart-drawer');

    if (cartDrawer) {
      cartDrawer.classList.toggle(
        'is-empty',
        parsedState.item_count === 0
      );
    }

    sections.forEach(function (section) {
      const sectionContainer = document.getElementById(section.id);

      if (!sectionContainer) return;

      const elementToReplace =
        sectionContainer.querySelector(section.selector) ||
        sectionContainer;

      const renderedSection =
        parsedState.sections[section.section];

      if (!renderedSection) return;

      elementToReplace.innerHTML = getSectionInnerHTML(
        renderedSection,
        section.selector
      );
    });

    if (
      typeof publish === 'function' &&
      typeof PUB_SUB_EVENTS !== 'undefined'
    ) {
      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: 'cart-extras',
      });
    }

    document.dispatchEvent(
      new CustomEvent('cartUpdated', {
        detail: {
          message: 'Cart was updated',
          source: 'cart-extras',
        },
      })
    );
  }

  function createCartRequestBody(data) {
    const sections = getSectionsToRender();

    return JSON.stringify(
      Object.assign({}, data, {
        sections: sections.map(function (section) {
          return section.section;
        }),
        sections_url: window.location.pathname,
      })
    );
  }

  function setCartLoading(isLoading) {
    const mainCartItems = document.getElementById(
      'main-cart-items'
    );

    if (mainCartItems) {
      mainCartItems.classList.toggle(
        'cart__items--disabled',
        isLoading
      );
    }
  }

  function normaliseProperties(parentProperties) {
    if (!parentProperties) return {};

    return Object.entries(parentProperties).reduce(function (
      properties,
      entry
    ) {
      const key = entry[0];
      const value = entry[1];

      if (Array.isArray(value)) {
        properties[value[0]] = value[1];
      } else {
        properties[key] = value;
      }

      return properties;
    },
    {});
  }

  window.addCartExtraForExperience = function (
    variantId,
    quantity,
    parentKey,
    parentTitle,
    parentProperties,
    button
  ) {
    const parsedVariantId = Number(variantId);
    const parsedQuantity = Math.max(1, Number(quantity) || 1);

    const existingProperties =
      normaliseProperties(parentProperties);

    const lineId = existingProperties._line_id || '';

    const buttonText = button
      ? button.querySelector('.button__text')
      : null;

    const spinner = button
      ? button.querySelector('.loading-overlay__spinner')
      : null;

    function setButtonLoading(isLoading) {
      if (!button) return;

      button.disabled = isLoading;
      button.classList.toggle('is-loading', isLoading);

      if (isLoading) {
        button.setAttribute('aria-busy', 'true');
      } else {
        button.removeAttribute('aria-busy');
      }

      if (buttonText) {
        buttonText.classList.toggle('hidden', isLoading);
      }

      if (spinner) {
        spinner.classList.toggle('hidden', !isLoading);
      }
    }

    if (
      !parsedVariantId ||
      !parentKey ||
      cartExtraRequestInProgress
    ) {
      return;
    }

    cartExtraRequestInProgress = true;
    setButtonLoading(true);
    setCartLoading(true);

    fetch(`${routes.cart_url}.js`, {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error('Failed to read cart');
        }

        return response.json();
      })
      .then(function (cart) {
        const extraAlreadyAdded = cart.items.some(function (cartItem) {
          const properties = cartItem.properties || {};

          return (
            cartItem.variant_id === parsedVariantId &&
            (
              properties._parent_line_id === lineId ||
              properties._parent_key === parentKey
            )
          );
        });

        if (extraAlreadyAdded) {
          return null;
        }

        return fetch(routes.cart_add_url, {
          ...fetchConfig(),
          body: createCartRequestBody({
            items: [
              {
                id: parsedVariantId,
                quantity: parsedQuantity,
                properties: {
                  _line_id: lineId,
                  _parent_line_id: lineId,
                  _parent_key: parentKey,
                  _requires_options: 'false',
                  'For experience': parentTitle || '',
                  Pricing: button?.dataset.pricingLabel || '',
                  'Applies to': button?.dataset.appliesToLabel || '',
                },
              },
            ],
          }),
        });
      })
      .then(function (response) {
        if (response === null) {
          return null;
        }

        if (!response.ok) {
          return response.text().then(function (text) {
            throw new Error(text || 'Failed to add extra');
          });
        }

        return response.json();
      })
      .then(function (parsedState) {
        if (!parsedState) return;

        renderCartSections(parsedState);
      })
      .catch(function (error) {
        setButtonLoading(false);

        handleCartError(
          error,
          'Could not add extra. Please try again.'
        );
      })
      .finally(function () {
        cartExtraRequestInProgress = false;
        setCartLoading(false);
      });
  };

  window.removeCartExtra = function (lineKey, button) {
  if (!lineKey || cartExtraRequestInProgress) {
    return;
  }

  const buttonText = button
    ? button.querySelector('.button__text')
    : null;

  const spinner = button
    ? button.querySelector('.loading-overlay__spinner')
    : null;

  function setButtonLoading(isLoading) {
    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle('is-loading', isLoading);

    if (isLoading) {
      button.setAttribute('aria-busy', 'true');
    } else {
      button.removeAttribute('aria-busy');
    }

    if (buttonText) {
      buttonText.classList.toggle('hidden', isLoading);
    }

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }
  }

  cartExtraRequestInProgress = true;
  setCartLoading(true);
  setButtonLoading(true);

  fetch(routes.cart_change_url, {
    ...fetchConfig(),
    body: createCartRequestBody({
      id: lineKey,
      quantity: 0,
    }),
  })
    .then(function (response) {
      if (!response.ok) {
        return response.text().then(function (text) {
          throw new Error(
            text || 'Failed to remove extra'
          );
        });
      }

      return response.json();
    })
    .then(function (parsedState) {
      renderCartSections(parsedState);
    })
    .catch(function (error) {
      setButtonLoading(false);

      handleCartError(
        error,
        'Could not remove extra. Please try again.'
      );
    })
    .finally(function () {
      cartExtraRequestInProgress = false;
      setCartLoading(false);
    });
};

window.removeExperienceAndExtras = function (
  lineId,
  parentKey,
  button,
  event
) {
  if (event) {
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
  }

  if (!lineId || cartExtraRequestInProgress) {
    return;
  }

  const buttonContent = button
    ? button.querySelector('.button__text')
    : null;

  const spinner = button
    ? button.querySelector('.loading-overlay__spinner')
    : null;

  function setButtonLoading(isLoading) {
    if (!button) return;

    button.disabled = isLoading;
    button.classList.toggle(
      'is-loading',
      isLoading
    );

    if (isLoading) {
      button.setAttribute(
        'aria-busy',
        'true'
      );
    } else {
      button.removeAttribute(
        'aria-busy'
      );
    }

    if (buttonContent) {
      buttonContent.classList.toggle(
        'hidden',
        isLoading
      );
    }

    if (spinner) {
      spinner.classList.toggle(
        'hidden',
        !isLoading
      );
    }
  }

  cartExtraRequestInProgress = true;
  setCartLoading(true);
  setButtonLoading(true);

  /*
   * Read the current cart first so we always work
   * with the latest Shopify cart state.
   */
  fetch(`${routes.cart_url}.js`, {
    headers: {
      Accept: 'application/json',
    },
  })
    .then(function (response) {
      if (!response.ok) {
        throw new Error(
          'Failed to fetch cart'
        );
      }

      return response.json();
    })
    .then(function (cart) {
      const parentItems = [];
      const extraItems = [];

      /*
       * Find the experience using _line_id and
       * all linked extras using _parent_line_id.
       */
      cart.items.forEach(function (cartItem) {
        const properties =
          cartItem.properties || {};

        const isParent =
          properties._line_id === lineId &&
          !properties._parent_line_id;

        const isExtra =
          properties._parent_line_id === lineId;

        if (isParent) {
          parentItems.push(cartItem);
        }

        if (isExtra) {
          extraItems.push(cartItem);
        }
      });

      if (!parentItems.length) {
        throw new Error(
          'Experience not found for line ID: ' +
            lineId
        );
      }

      const itemsToRemove =
        extraItems.concat(parentItems);

      const updates = {};

      itemsToRemove.forEach(function (cartItem) {
        updates[cartItem.key] = 0;
      });

      const sections =
        getSectionsToRender();

      return fetch(routes.cart_update_url, {
        method: 'POST',
        headers: {
          'Content-Type':
            'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          updates: updates,

          sections: sections.map(
            function (section) {
              return section.section;
            }
          ),

          sections_url:
            window.location.pathname,
        }),
      });
    })
    .then(function (response) {
      if (!response.ok) {
        return response
          .text()
          .then(function (text) {
            throw new Error(
              text ||
                'Failed to remove experience'
            );
          });
      }

      return response.json();
    })
    .then(function (parsedState) {
      renderCartSections(parsedState);
    })
    .catch(function (error) {
      console.error(
        'removeExperienceAndExtras failed:',
        error
      );

      setButtonLoading(false);

      handleCartError(
        error,
        'Could not remove the item. Please try again.'
      );
    })
    .finally(function () {
      cartExtraRequestInProgress = false;
      setCartLoading(false);
    });
};
})();